import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
// @ts-ignore
import { AxiosProvider } from 'react-axios'
import 'bootstrap/dist/css/bootstrap.css'
import '@patternfly/react-core/dist/styles/base.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'
import { getCurrentUser } from './features/users/authSlice'
import { axios } from './utils/api'

store.dispatch(getCurrentUser())

ReactDOM.render(
    <Provider store={store}>
        <AxiosProvider instance={axios}>
            <App />
        </AxiosProvider>
    </Provider>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
